<template>
  <div class="container-fluid" id="Verificacao">
    <LoadingPage v-if="!ready" />
    <div v-if="ready">
      <div v-if="temBoleto">
        <div id="boleto_parceiro">
          <table class="table" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td v-if="urlLogoDocumentos">
                <img
                  :src="urlLogoDocumentos"
                  alt="Logo"
                  style="max-width: 120px; max-height: 50px; object-fit: contain;"
                />
              </td>
              <td width-25 id="header-primary">{{ banco.codigo }}</td>
              <td text-right width-50 class="header-secondary">
                RECIBO DO PAGADOR
              </td>
            </tr>
          </table>

          <table
            width-100
            border="0"
            cellspacing="0"
            border-bottom
            cellpadding="0"
            id="boleto_parceiro_info"
          >
            <tr>
              <td width-25 border-right style="padding: 5px 30px 5px 5px;">
                <div>Beneficiário:</div>
                <div style="padding: 3px 0 13px 0; ">
                  <b>{{ beneficiario.nome }}</b>
                </div>
                <div>
                  CNPJ: <b>{{ cnpjMascaraBeneficiario }}</b>
                </div>
              </td>
              <td
                width-25
                border-right
                style="padding: 5px 30px 5px 5px;"
                initial
              >
                <div>Agência/Cod.Beneficiário:</div>
                <div>{{ agencia }}</div>
              </td>
              <td
                width-25
                border-right
                style="padding: 5px 30px 5px 5px;"
                initial
              >
                <div>Data de Emissão:</div>
                <div>
                  <b>{{ dataEmissao }}</b>
                </div>
              </td>
              <td width-25 style="padding:5px" initial>
                <div>Data de Vencimento</div>
                <div text-right>
                  <b> {{ dataVencimento }}</b>
                </div>
              </td>
            </tr>
          </table>

          <table
            width-100
            border="0"
            border-bottom
            cellspacing="0"
            cellpadding="0"
            id="boleto_parceiro_info"
          >
            <tr>
              <td width-25 border-right style="padding: 5px 30px 5px 5px;">
                <div style="padding-bottom: 3px">Pagador:</div>
                <div>
                  <b> {{ pagador.nome }}</b>
                </div>
              </td>
              <td width-25 border-right style="padding: 5px 30px 5px 5px;">
                <div style="padding-bottom: 3px">Nosso número:</div>
                <div>
                  <b> {{ nossoNumero }}</b>
                </div>
              </td>
              <td
                width-25
                border-right
                style="padding: 5px 30px 5px 5px;"
                initial
              >
                <div style="padding-bottom: 3px">Número Documento:</div>
                <div>
                  <b> {{ numeroDocumento }}</b>
                </div>
              </td>
              <td width-25 style="padding: 5px;" initial>
                <div style="padding-bottom: 3px">Valor Documento:</div>
                <div text-right>
                  <b> {{ valorBoleto }}</b>
                </div>
              </td>
            </tr>
          </table>

          <table
            width-100
            border="0"
            border-bottom
            cellspacing="0"
            cellpadding="0"
            id="boleto_parceiro_info"
          >
            <tr>
              <td style="padding: 5px 30px 5px 5px;">
                <div style="padding-bottom: 3px">Referência:</div>
                <div style="padding-bottom: 3px">
                  <b> {{ referencia }}</b>
                </div>
              </td>
            </tr>
          </table>

          <table
            width-100
            border="0"
            border-bottom-dashed
            cellspacing="0"
            cellpadding="0"
            id="boleto_parceiro_info"
          >
            <tr>
              <td style="padding: 10px 5px 30px 5px;">
                <div
                  style="padding-bottom: 3px"
                  class="header-secondary"
                  text-right
                >
                  Autenticação Mecanica
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div id="boleto">
          <table class="table" border="0" cellspacing="0" cellpadding="0">
            <tr>
              <td id="header-primary">{{ banco.codigo }}</td>
              <td text-right id="header-number">
                {{ linhaDigitavel }}
              </td>
            </tr>
          </table>

          <table
            style="width: 100%;"
            cellspacing="0"
            cellpadding="0"
            border-bottom-left-right
          >
            <tr>
              <td style="padding: 5px" initial>Local de Pagamento</td>
              <td width-60 style="padding: 7px 5px 5px 0" border-right>
                <div>
                  <b>{{ banco.nome_completo }} </b>
                </div>
                <div>
                  Pagável preferencialmente em qualquer agência
                </div>
              </td>
              <td width-25 style="padding: 5px">
                <div>Data de Vencimento</div>
                <div text-right>
                  <b> {{ dataVencimento }}</b>
                </div>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%;"
            cellspacing="0"
            cellpadding="0"
            border-bottom-left-right
          >
            <tr>
              <td width-75 border-right style="padding: 5px 30px 5px 5px;">
                <div>Beneficiário:</div>
                <div style="padding: 2px 0 13px 0; ">
                  <b>{{ beneficiario.nome }}</b>
                </div>
                <div>CNPJ: {{ cnpjMascaraBeneficiario }}</div>
              </td>
              <td style="padding: 5px;" initial>
                <div style="padding-bottom: 3px;">
                  Agência/Cod.Beneficiário:
                </div>
                <div text-right>
                  <b> {{ agencia }}</b>
                </div>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%;"
            cellspacing="0"
            cellpadding="0"
            border-bottom-left-right
          >
            <tr>
              <td style="width: 17.5%; padding:5px;" border-right>
                <div>Data Documento:</div>
                <div text-center>
                  <b>{{ dataEmissao }}</b>
                </div>
              </td>
              <td style="width: 25%; padding:5px;" border-right>
                <div>N Documento</div>
                <div text-center>
                  <b>{{ numeroDocumento }}</b>
                </div>
              </td>
              <td style="width: 10% ;padding: 5px;" border-right>
                <div style="padding-bottom: 3px;">Espécie Doc.</div>
                <div text-center><b>Outro</b></div>
              </td>
              <td style="width: 7.5% ;padding: 5px;" border-right>
                <div style="padding-bottom: 3px;">Aceite</div>
                <div text-center><b> N</b></div>
              </td>
              <td style="width: 15% ;padding: 5px;" border-right>
                <div style="padding-bottom: 3px;">Data Processamento</div>
                <div text-center>
                  <b> {{ dataEmissao }}</b>
                </div>
              </td>
              <td style="width: 25.5% ;padding: 5px;">
                <div style="padding-bottom: 3px;">Nosso Número</div>
                <div text-right>
                  <b> {{ nossoNumero }} </b>
                </div>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%;"
            cellspacing="0"
            cellpadding="0"
            border-bottom-left-right
          >
            <tr>
              <td style="width: 17.5%; padding:5px;" border-right initial>
                <div>Uso do Banco</div>
              </td>
              <td style="width: 10%; padding:5px;" border-right>
                <div>Cip</div>
                <div text-center>
                  <b>{{ cip }}</b>
                </div>
              </td>
              <td style="width: 15%; padding:5px;" border-right>
                <div>Carteira</div>
                <div text-center>
                  <b>{{ carteira }}</b>
                </div>
              </td>
              <td style="width: 10%;" border-right>
                <div style="padding-bottom: 3px;" text-center>
                  Espécie Moeda
                </div>
                <div text-center><b>Real</b></div>
              </td>
              <td style="width: 7.5% ;" border-right initial>
                <div style="padding-bottom: 3px;" text-center>Quantidade</div>
              </td>
              <td style="width: 15%;padding: 5px;" border-right initial>
                <div style="padding-bottom: 3px;">Valor</div>
              </td>
              <td style="width: 25.5% ;padding: 5px;">
                <div style="padding-bottom: 3px;">Valor do Documento</div>
                <div text-right>
                  <b> {{ valorBoleto }} </b>
                </div>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%;"
            cellspacing="0"
            cellpadding="0"
            border-bottom-left-right
          >
            <tr>
              <td
                style="width: 59.8%; padding: 10px 5px 100px 5px; line-height: 1.4;"
                border-right
              >
                <div text-left v-if="!instrucoes">
                  <b>
                    -Pague até a data de vencimento em qualquer banco, lotérica
                    ou aplicativo de pagamento. <br />
                    -Após o vencimento, o pagamento deve ser feito no banco
                    emissor ou via internet banking, com possíveis acréscimos de
                    multa e juros. <br />
                    -Para dúvidas, entre em contato com nosso atendimento ao
                    cliente.
                  </b>
                </div>

                <div
                  v-else
                  class="text-left"
                  v-html="sanitizeInstrucoes()"
                  style="font-weight: bold;"
                ></div>
              </td>
              <td style="width: 20%; padding:5px;line-height: 1.4;" initial>
                <div>(-) Desconto/Abatimento</div>
                <div>(-) Outras Deduções</div>
                <div>(+) Mora/Multa</div>
                <div>(+) Outros Acréscimos</div>
                <div>(+) Valor Cobrado</div>
              </td>
            </tr>
          </table>

          <table
            style="width: 100%;"
            cellspacing="0"
            cellpadding="0"
            border-bottom-left-right
          >
            <tr>
              <td
                style="width: 5%; padding-left: 5px; line-height: 1.4;"
                initial
              >
                Pagador:
              </td>
              <td
                style="width: 54.2%; padding: 10px 5px 40px 5px; line-height: 1.4;"
                border-right
                initial
              >
                <div>{{ pagador.nome }}</div>
                <div>{{ pagador.endereco }}</div>
                <div>Sacador/Avalista: {{ beneficiario.nome }}</div>
              </td>
              <td
                style="width: 20%; padding:5px 5px 20px 5px; vertical-align: bottom;"
                text-center
              >
                Ficha de Compensação
              </td>
            </tr>
          </table>

          <table style="width: 100%;" cellspacing="0" cellpadding="0">
            <tr>
              <td initial>
                <div
                  v-if="barcodeSVG"
                  v-html="barcodeSVG"
                  class="barcode"
                ></div>
              </td>
              <td style="width: 25%; padding-top: 20px;vertical-align: top;">
                <div class="header-secondary">Autenticação Mecânica</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingPage from "@/components/LoadingPage";
import ApiWeb from "../service/api-web";
import * as _ from "lodash";
import moment from "moment";
import Boleto from "boleto.js";
import DOMPurify from "dompurify";

export default {
  name: "Boleto",
  components: {
    LoadingPage
  },
  data: () => ({
    ready: false,
    mensagemErro: null,
    idBoleto: "",
    s3BucketRoot: "",
    banco: {
      codigo: "000-0",
      nome_completo: ""
    },
    beneficiario: {
      nome: "",
      cnpj: "",
      endereco: "",
      cidade: ""
    },
    agencia: "",
    dataEmissao: "",
    dataVencimento: "",
    nossoNumero: "",
    numeroDocumento: "",
    valorBoleto: "",
    referencia: "",
    codigoBarra: "",
    linhaDigitavel: "",
    cip: "",
    carteira: "",
    pagador: {
      nome: "",
      endereco: ""
    },
    instrucoes: "",
    barcodeSVG: null,
    idFornecedor: null
  }),
  computed: {
    cnpjMascaraBeneficiario() {
      if (this.beneficiario) {
        return this.beneficiario.cnpj.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      } else {
        return "";
      }
    },
    temBoleto() {
      return this.mensagemErro === "";
    },
    urlLogoDocumentos() {
      if (this.idFornecedor && this.s3BucketRoot) {
        return `${this.s3BucketRoot}/fornec-space/logos/documentos/${this.idFornecedor}`;
      }
      return null;
    }
  },
  watch: {
    mensagemErro: function(newMessage) {
      if (newMessage) {
        this.$vueOnToast.pop("error", newMessage);
      }
    },
    linhaDigitavel() {
      try {
        if (this.linhaDigitavel) {
          this.barcodeSVG = new Boleto(this.linhaDigitavel).toSVG();
        } else {
          this.barcodeSVG = null;
        }
      } catch (err) {
        this.barcodeSVG = null;
      }
    }
  },
  created() {
    this.idBoleto = this.$route.params.idBoleto || "";
    ApiWeb.v2.faturas
      .getFatura(this.idBoleto)
      .then(resp => {
        if (resp.data && !_.isEmpty(resp.data.dados)) {
          this.mensagemErro = "";
          this.idFornecedor = _.get(resp.data, "idfornecedor", "");
          this.mapDadosBoleto(resp.data);
          this.getS3BucketRoot();
        } else {
          this.mensagemErro = "Dados Faltantes para exibição do Boleto!";
        }
        this.ready = true;
      })
      .catch(() => {
        this.ready = true;
        this.mensagemErro = "Fatura Não encotrada!";
      });
  },
  methods: {
    getS3BucketRoot() {
      if (this.idFornecedor) {
        ApiWeb.v4.theme.obterS3BucketRoot(this.idFornecedor).then(resp => {
          if (resp.data) {
            this.s3BucketRoot = _.get(resp.data, "s3BucketRoot") || "";
          }
        });
      }
    },
    mapDadosBoleto(dados) {
      this.idBoleto = _.get(dados, "idfaturacliente", "");
      this.banco.codigo = _.get(dados, "dados.numeroBanco", "000-0");
      this.banco.nome_completo = _.get(dados, "nomebanco", "");
      this.beneficiario.nome = _.get(dados, "dados.beneficiario", "");
      this.beneficiario.cnpj = _.get(
        dados,
        "dados.cnpjBeneficiario",
        ""
      ).toString();
      this.agencia = _.get(dados, "dados.agencia", "");
      this.dataEmissao = moment(_.get(dados, "dados.dataEmissao", "")).format(
        "DD/MM/YYYY"
      );
      this.dataVencimento = moment(_.get(dados, "data_vencimento", "")).format(
        "DD/MM/YYYY"
      );
      this.nossoNumero = _.get(dados, "dados.nossoNumeroBanco", "");
      this.numeroDocumento = _.get(dados, "dados.numeroDuplicata", "00000");
      this.valorBoleto = `R$${Number(_.get(dados, "valor_total", "")).toFixed(
        2
      )}`;
      this.referencia = _.get(dados, "", "REFERENCIA");
      this.codigoBarra = _.get(dados, "codigo_barras", "");
      this.linhaDigitavel = _.get(
        dados,
        "linha_digitavel",
        "00000.00000 00000.000000 00000.000000 0 00000000000000"
      );
      this.cip = _.get(dados, "", "0");
      this.carteira = _.get(dados, "dados.carteira", "");
      this.pagador.nome = _.get(dados, "nomepagador", "");
      this.pagador.endereco = _.get(dados, "enderecopagador", "");
      this.instrucoes = _.get(dados, "dados.instrucoes", "");
    },
    sanitizeInstrucoes() {
      return DOMPurify.sanitize(this.instrucoes);
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  height: auto;
  overflow: scroll;
}
#boleto_parceiro {
  width: 666px;
  font-family: Arial, Helvetica, sans-serif;
  margin-bottom: 15px;
}
.am {
  font-size: 9px;
  color: #333333;
  height: 10px;
  font-weight: bold;
  margin-bottom: 2px;
  text-align: center;
  width: 320px;
  border: 1px solid #000;
  border-right-width: 2px;
  border-left-width: 2px;
  border-bottom-width: 0;
}
#boleto {
  height: 416px;
  width: 666px;
  color: #000000;
  font-family: Arial, Helvetica, sans-serif;
  word-spacing: -1px;
  font-size: 8.5px;
}

.logo {
  width: 120px;
  margin-bottom: 5px;
}

.table {
  width: 666px;
  height: 28px;
  border-bottom: solid;
  border-bottom-color: #000000;
  border-bottom-width: 5px;
}
[width-25] {
  width: 25%;
}
[width-50] {
  width: 50%;
}
[width-100] {
  width: 100%;
}

[width-75] {
  width: 75%;
}

[width-12-5] {
  width: 12.5%;
}

[width-60] {
  width: 60%;
}

[text-right] {
  text-align: right;
}

[text-left] {
  text-align: left;
}

[text-center] {
  text-align: center;
}

[border-right] {
  border-right: 1.5px solid;
}

[border-bottom] {
  border-bottom: 1.5px solid;
}

[border-bottom-dashed] {
  border-bottom: 2px dashed;
}
[border-bottom-left-right] {
  border-bottom: 1.5px solid;
  border-right: 1.5px solid;
  border-left: 1.5px solid;
}

[initial] {
  vertical-align: initial;
}

#header-primary {
  font-size: 20px;
  font-weight: bold;
}
.header-secondary {
  font-size: 12px;
  font-weight: bold;
}

#header-number {
  font-size: 14px;
  font-weight: bold;
}

#boleto_parceiro_info {
  font-size: 8.5px;
}

.barcode {
  margin-top: 1em;
}
</style>
